var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVotingHeart = function SvgVotingHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.746 45.511c0 27.329-24.581 49.6-61.888 83.433l-10.411 9.544-10.411-9.544C24.73 95.108.148 72.84.148 45.511A39.378 39.378 0 0 1 39.913 5.747a43.479 43.479 0 0 1 32.534 15.182 43.482 43.482 0 0 1 32.535-15.182 39.378 39.378 0 0 1 39.764 39.764Z",
    fill: "#fff"
  })));
};
export default SvgVotingHeart;